import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "./style.css";
import { currencies } from "../../../../constants/jsonConstant";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import { useState, useEffect } from "react";
import { Slider } from "@mui/material";
const Promotionrightside = ({ promoteShop, setPromoteShop, promotData, estimateAudience, estimatedAudience = 0, isEstimating = false }) => {
  const [currencies, setCurrencies] = useState({});

  const [selectedCurrency, setSelectedCurrency] = useState({
    code: "USD",
    rate: 1,
  });
  const [val, setVal] = useState();
  const [error, setError] = useState("");

  // Local calendar date (YYYY-MM-DD) — disables past days / months / years in the picker
  const todayStr = (() => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  })();

  const endDateMin =
    promoteShop.startDate && promoteShop.startDate > todayStr
      ? promoteShop.startDate
      : todayStr;

  useEffect(() => {
    // Use plain fetch (not axios) to avoid withCredentials CORS issues on external APIs
    fetch("https://v6.exchangerate-api.com/v6/9b982c1d37eac2d2ed2b753f/latest/USD")
      .then((res) => res.json())
      .then((data) => {
        setCurrencies(data.conversion_rates || {});
      })
      .catch((err) => console.error("Currency fetch error:", err));

    // Keep slider/input in sync with existing budget if present
    if (promoteShop.dailyBudget) {
      setVal(Number(promoteShop.dailyBudget));
    }
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      const country = promoteShop.location?.country;
      const cleanCountry = country && !/^select/i.test(String(country).trim()) ? country : "";
      const hasBudget =
        promoteShop.dailyBudget !== "" &&
        promoteShop.dailyBudget != null &&
        Number(promoteShop.dailyBudget) > 0;

      // Estimate as soon as daily budget or targeting is changed
      if ((hasBudget || cleanCountry) && typeof estimateAudience === "function") {
        estimateAudience({
          ...promoteShop,
          currency: selectedCurrency.code,
          currencyRate: selectedCurrency.rate,
        });
      }
    }, 200);

    return () => clearTimeout(delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    promoteShop.location?.country,
    promoteShop.location?.state,
    promoteShop.location?.city,
    promoteShop.ageMin,
    promoteShop.ageMax,
    promoteShop.gender,
    promoteShop.businessTypes,
    promoteShop.dailyBudget,
    selectedCurrency.code,
    selectedCurrency.rate,
    estimateAudience,
  ]);

  const businessMap = {
    "General Public": "generalPublic",
    Retailer: "retailerShop",
    Wholesaler: "wholesellerShop",
    Manufacturer: "manufacturerShop",
    "Raw Material": "rawMaterialShop",
    Services: "services",
    Transportation: "transportShopItem",
    Farming: "farmingShop",
    "Recycled Material": "recycledShop",
    "Gems and Jewelry": "gemShop",
    "Used Items": "usedShop",
    "Used Vehicles": "usedVehicleShop",
  };

  const handleBusinessType = (value) => {
    let updated = [...promoteShop.businessTypes];

    if (updated.includes(value)) {
      updated = updated.filter((item) => item !== value);
    } else {
      updated.push(value);
    }

    setPromoteShop({
      ...promoteShop,
      businessTypes: updated,
    });
  };
  const handleCurrencyChange = (e) => {
    const code = e.target.selectedOptions[0].getAttribute("data-code");
    const rate = parseFloat(e.target.value);
    setSelectedCurrency({ code, rate });
    setVal(rate);
    const updated = {
      ...promoteShop,
      currency: code,
      currencyRate: rate,
      dailyBudget: rate,
    };
    setPromoteShop(updated);
    if (typeof estimateAudience === "function") {
      estimateAudience(updated);
    }
  };

  const validateValue = (newVal) => {
    setVal(newVal);

    const valueInUSD = newVal / selectedCurrency.rate;

    if (valueInUSD < 1) {
      setError("Value must be at least 1 USD!");
    } else {
      setError("");
    }
  };

  const handleInputChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, "");
    if (rawValue === "") {
      validateValue("");
      const updated = {
        ...promoteShop,
        dailyBudget: "",
        currency: selectedCurrency.code,
        currencyRate: selectedCurrency.rate,
      };
      setPromoteShop(updated);
      if (typeof estimateAudience === "function") {
        estimateAudience(updated);
      }
      return;
    }
    const value = Number(rawValue);
    if (isNaN(value)) return;

    validateValue(value);

    const updated = {
      ...promoteShop,
      dailyBudget: value,
      currency: selectedCurrency.code,
      currencyRate: selectedCurrency.rate,
    };
    setPromoteShop(updated);
    if (typeof estimateAudience === "function") {
      estimateAudience(updated);
    }
  };

  const handleSliderInput = (e, newValue) => {
    validateValue(newValue);

    const updated = {
      ...promoteShop,
      dailyBudget: newValue,
      currency: selectedCurrency.code,
      currencyRate: selectedCurrency.rate,
    };
    setPromoteShop(updated);
    if (typeof estimateAudience === "function") {
      estimateAudience(updated);
    }
  };

return (
    <div>
      <Container>
        <div className="pe-2 pt-2">
          <h5 className="heading-top">Enter detail of your ad.</h5>
          <h6 className="pt-2">
            Select your platform you want to display your ad
          </h6>

          <Row>
            <Col
              lg="4"
              md="4"
              sm="4"
              xs="6"
              className="px-sm-2 px-md-0 px-lg-0"
            >
              {Object.entries(businessMap).map(([label, value]) => (
                <div key={value} className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={promoteShop.businessTypes.includes(value)}
                    onChange={() => handleBusinessType(value)}
                  />
                  <p className="check-text m-1">{label}</p>
                </div>
              ))}
            </Col>
          </Row>

          <div className="pt-3 col-5 ">
            <h5 className="">Select Ads display area</h5>
            <Form.Select
              className="border_3 promote-inputs-style"
              onChange={(e) =>
                setPromoteShop({
                  ...promoteShop,
                  placement: e.target.value,
                })
              }
            >
              <option value="">Select placement</option>
              <option value="feed">Feed</option>
              <option value="sidebar">Sidebar</option>
              <option value="banner">Banner</option>
            </Form.Select>
          </div>

          <h5 className="pt-4">Select your ad duration</h5>
          <Row className="justify-content-start">
            <Col lg="4">
              <div className="d-flex flex-column">
                <label className="h6">Start Date</label>
                <input
                  type="date"
                  className="me-2 border_3 promote-inputs-style p-1"
                  value={promoteShop.startDate || ""}
                  min={todayStr}
                  onChange={(e) => {
                    const startDate = e.target.value;
                    const next = { ...promoteShop, startDate };
                    // If end date is before the new start, clear it
                    if (promoteShop.endDate && promoteShop.endDate < startDate) {
                      next.endDate = "";
                    }
                    setPromoteShop(next);
                  }}
                />
              </div>
            </Col>

            <Col lg="4">
              <div className="d-flex flex-column">
                <label className="h6">End Date</label>
                <input
                  type="date"
                  className="border_3 promote-inputs-style p-1"
                  value={promoteShop.endDate || ""}
                  min={endDateMin}
                  disabled={!promoteShop.startDate}
                  onChange={(e) =>
                    setPromoteShop({
                      ...promoteShop,
                      endDate: e.target.value,
                    })
                  }
                />
                {!promoteShop.startDate && (
                  <span className="text-muted mt-1" style={{ fontSize: "11px" }}>
                    Select a start date first
                  </span>
                )}
              </div>
            </Col>
          </Row>
          <div className="pt-3 col-5 ">
            <h5 className="">Select country currency</h5>

            <Form.Select
              className="border_3 promote-inputs-style"
              aria-label="Select currency"
              onChange={handleCurrencyChange}
              value={selectedCurrency.rate}
            >
              {Object.entries(currencies).map(([code, rate]) => (
                <option key={code} value={rate} data-code={code}>
                  {code}
                </option>
              ))}
            </Form.Select>
          </div>

          <div className="pt-3 w-75">
            <h5>Daily budget</h5>
            <div className="d-flex">
              <p className="font_14 mb-0" style={{ color: "#1976d2" }}>
                <b>{selectedCurrency?.code}:</b>
              </p>
              &nbsp;
              <Input
                value={val !== undefined && val !== "" ? Number(val).toLocaleString("en-US") : ""}
                size="small"
                className="font_13 pb-0"
                onChange={handleInputChange}
                type="text"
                style={{ color: "#1976d2" }}
              />
            </div>

            <Slider
              value={typeof val === "number" ? val : 0}
              onChange={handleSliderInput}
              aria-labelledby="slider-with-input"
              color="primary"
              min={10}
              max={100000}
            />

            {error && <p style={{ color: "red", marginTop: "5px" }}>{error}</p>}
          </div>

          <h5 className="pt-1">Estimated audience</h5>
          <Row className="d-flex justify-content-left">
            <Col lg="9" md="6" sm="6" xs="12">
              <div className="d-flex align-items-center gap-2">
                <input
                  className="text-center border_3 promote-inputs-style"
                  style={{ width: "min(100%, 220px)" }}
                  value={
                    isEstimating
                      ? "Calculating..."
                      : `${Number(estimatedAudience || 0).toLocaleString()} total users`
                  }
                  readOnly
                />
                {isEstimating && (
                  <span className="spinner-border spinner-border-sm text-primary" role="status" />
                )}
              </div>
              {!isEstimating && (!estimatedAudience || estimatedAudience === 0) && (
                <p className="text-muted mt-1 mb-0" style={{ fontSize: "12px" }}>
                  Set your daily budget to calculate estimated reachable audience.
                </p>
              )}
            </Col>
          </Row>

          <Row className="d-flex justify-content-end">
            <Col lg="3 flex-end mt-4 pt-1" md="6" sm="6" xs="6">
              <button
                className="btns-end rounded pt-1 pb-1 ps-3 pe-3"
                onClick={() => {
                  promotData();
                }}
              >
                Place ad
              </button>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Promotionrightside;
